import React from "react";
import { 
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Row,
    Table,
    UncontrolledTooltip
} from "reactstrap";

// Requests
import { getProjectsRequest } from "api/project";
import { deleteProjectRequest } from "api/project";
// Components
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
// Helpers
import { hasPermission } from "helpers/auth";

class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            total: 0,
            pages: 0,
            start_page: 0,
            end_page: 9,
            loading: true,
            filters: { limit: 25 }
        }
        this.timeout = null;
    };

    async componentDidMount() {
        await this.getProjects()
    }

    getProjects = async () => {
        this.setState({ loading: true })

        const { filters } = this.state;
        const projectsObj = await getProjectsRequest(filters)
        const projects = projectsObj.projects;
        const total = projectsObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            projects,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    }

    openConfirmation = (id) => () => {
		this.setState({
			deleteProjectId: id
		});
		this.deleteConfirmationModal.toggle();
    }

    deleteProject = async () => {
		const { deleteProjectId } = this.state;
        await deleteProjectRequest(deleteProjectId);
        this.getProjects()
	}

    goTo = path => this.props.history.push(path);

    render () {
        const {
            loading,
            projects
        } = this.state;

        return (
            <div className="content">
                <Row>
					<Col md="12">
						<Card>
							<CardHeader>
								<CardTitle className="mb-5" tag="h4">
									Projects
                                    {hasPermission('CreateProject') ? <Button className="pull-right mb-3 add-btn" color="primary" onClick={() => this.goTo('/project/create')}><i className="tim-icons icon-simple-add" /> Project</Button> : null}
								</CardTitle>
                            </CardHeader>
                            <CardBody>
								<Table responsive>
                                <thead className="text-primary">
									<tr>
										<th>Name</th>
										<th>Description</th>
										<th>Max Commission</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
                                <tbody>
                                    {loading ?
                                        <tr>
                                            <td colSpan="4">Loading...</td>
                                        </tr>

                                    :   <>
                                        {projects && projects.length > 0 ?
                                            <>
                                            {projects.map(project => (
                                                <tr>
                                                    <td>{project.name}</td>
                                                    <td>{project.description || "N/A"}</td>
                                                    <td>{project.maxCommission || 7.5}%</td>
                                                    <td className="text-right">
                                                        <Button
                                                            className="btn-link btn-icon"
                                                            color="success"
                                                            id={`tooltip-view-${project._id}`}
                                                            size="sm"
                                                            onClick={() => this.goTo(`/project?id=${project._id}`)}
                                                        >
                                                            <i className="tim-icons icon-zoom-split" />
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            delay={0}
                                                            target={`tooltip-view-${project._id}`}
                                                        >
                                                            View
                                                        </UncontrolledTooltip>
                                                        {hasPermission('EditUser') ? <>
                                                            <Button
                                                                className="btn-link btn-icon"
                                                                color="info"
                                                                id={`tooltip-edit-${project._id}`}
                                                                size="sm"
                                                                onClick={() => this.goTo(`/project/edit?id=${project._id}`)}
                                                            >
                                                                <i className="tim-icons icon-pencil" />
                                                            </Button>
                                                            <UncontrolledTooltip
                                                                delay={0}
                                                                target={`tooltip-edit-${project._id}`}
                                                            >
                                                                Edit
                                                            </UncontrolledTooltip>
                                                            <Button
                                                                className="btn-link btn-icon"
                                                                color="danger"
                                                                id={`tooltip-delete-${project._id}`}
                                                                size="sm"
                                                                onClick={this.openConfirmation(project._id)}
                                                            >
                                                                <i className="tim-icons icon-simple-remove" />
                                                            </Button>
                                                            <UncontrolledTooltip
                                                                delay={0}
                                                                target={`tooltip-delete-${project._id}`}
                                                            >
                                                                Delete
                                                            </UncontrolledTooltip>
                                                        </> : null}
                                                    </td>
                                                </tr>
                                            )) }
                                            </>
                                        :
                                            <tr>
                                                <td colSpan="4">There's no project to show!</td>
                                            </tr>
                                        }
                                        </>
                                    }
                                </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <ConfirmationModal
                    ref={el => this.deleteConfirmationModal = el}
                    title="Delete Project?"
                    buttons={[
                        { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                        { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteProject }
                    ]}
                >
                    Are you sure you want to delete this project?
                </ConfirmationModal>
            </div>
        )
    }
}

export default Projects;